module.exports = __webpack_public_path__ + "assets/img/thumb_ch3-item-0.90ca44e4.jpg";